var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { useCallback, useEffect, useState } from "react";
// import ReactGridLayout, {
//   Layout,
//   ReactGridLayoutProps,
//   Responsive,
//   WidthProvider,
// } from "react-grid-layout";
import { captureCleverTabAnalytics } from "src/utils/analytics";
import { closeGreeksWebSocket } from "src/utils/greeks-web-socket";
// import { v4 as uuid } from "uuid";
import { searchFOScrip, getIndexPCR, } from "../../apis/dashboard";
import { useAppSelector } from "../../hooks/redux";
import { getNearestExpiryElement } from "../../utils/methods";
import FII from "./fii/fii";
import FOMomentum from "./fo-momentum/fo-momentum";
import OptionChain from "./option-chain/option-chain";
import Overview from "./overview/overview";
// import Vix from "./vix/vix";
import styles from "./showcase.module.scss";
import VixWrapper from "./vix/VixWrapper";
import { getScripCodeFromExpiry } from "../fno-stats/fno-stats-commonmethods";
// const ResponsiveReactGridLayout = WidthProvider(Responsive);
const Showcase = (props) => {
    // const isDraggable = useAppSelector((state) => state.app.isDraggable);
    const defaultLayouts = useAppSelector((state) => state.app.default_layouts);
    //const updatedScripcodes = useAppSelector((state) => state.modals.updatedScripcodes);
    const [niftyLoader, setNiftyLoader] = useState(true);
    const [backNiftyLoader, setBankNiftyLoader] = useState(true);
    const [niftyError, setNiftyError] = useState(false);
    const [bankNiftyError, setBankNiftyError] = useState(false);
    // const {
    //   cols = { lg: 12, md: 12, sm: 12, xs: 12, xxs: 12 },
    //   initialLayout = { ...defaultLayouts },
    // } = props;
    // const [compactType] = useState<ReactGridLayoutProps["compactType"]>();
    // const [mounted, setMounted] = useState(false);
    // const [currentBreakpoint, setCurrentBreakpoint] = useState("lg");
    // const [layouts, setLayout] = useState<ReactGridLayout.Layouts>(initialLayout);
    // const [hideChartIframe, setHideChartIframe] = useState(true);
    const [indexPCRArr, setIndexPCRArr] = useState([]);
    const [optionList, setOptionList] = useState([
        {
            scripCode: 35382,
            symbol: "NIFTY",
            expiry: "",
            exch: "N",
            exchType: "D",
            spotToken: 999920000,
            title: "Nifty",
            indicatorWidget: "NIFTY 50",
        },
        {
            scripCode: 35006,
            symbol: "BANKNIFTY",
            expiry: "",
            exch: "N",
            exchType: "D",
            spotToken: 999920005,
            title: "BankNifty",
            indicatorWidget: "NIFTY BANK",
        },
        // {
        //   scripCode: 0,
        //   symbol: "TCS",
        //   expiry: "",
        //   exch: "N",
        //   exchType: "D",
        //   spotToken: 68779,
        //   title: "TCS",
        // },
        // {
        //   scripCode: 0,
        //   symbol: "IDEA",
        //   expiry: "",
        //   exch: "N",
        //   exchType: "D",
        //   spotToken: 64024,
        //   title: "IDEA",
        // }
    ]);
    // const ref_socketConnection = useRef(false);
    // Added for new dashboard layouts mp
    const singleScrip = optionList[0];
    const singleScripBN = optionList[1];
    useEffect(() => {
        captureCleverTabAnalytics("Overview Page - FNO", {
            eventName: "Overview Page - FNO",
        });
        captureCleverTabAnalytics("Dashboard Landed", {
            eventName: "Dashboard Landed",
        });
    }, []);
    useEffect(() => {
        // if (!ref_socketConnection.current) {
        //   reSubscribeGreeksSocket();
        //   ref_socketConnection.current = true;
        // }
        return () => {
            closeGreeksWebSocket();
        };
    }, []);
    // useEffect(() => {
    //   setMounted(true);
    // }, []);
    // const onBreakpointChange = useCallback(
    //   (breakpoint: string) => {
    //     setCurrentBreakpoint(breakpoint);
    //     setLayout({ ...layouts, ...{ [breakpoint]: layouts[breakpoint] } });
    //   },
    //   [layouts]
    // );
    // const searchUIDRef = useRef(uuid());
    const fetchOptions = useCallback((element, index) => __awaiter(void 0, void 0, void 0, function* () {
        try {
            // const searchFNOResp = await dashboardWorkerRef.searchFOScripImpl(
            //   element.symbol
            // );
            const searchFNOResp = yield searchFOScrip(element.symbol);
            // console.log(searchFNOResp);
            const nearestFutureData = getNearestExpiryElement(searchFNOResp.data.Data, element.symbol.toUpperCase());
            element.scripCode = nearestFutureData.ScripCode;
            element.expiry = nearestFutureData.Expiry;
            element.LastRate = nearestFutureData.LastRate;
            element.PClose = nearestFutureData.PClose;
            // element
            index === 0 ? setNiftyLoader(false) : setBankNiftyLoader(false);
            setOptionList([...optionList]);
        }
        catch (err) {
            console.error(err);
            index === 0 ? setNiftyLoader(false) : setBankNiftyLoader(false);
            // index === 0 ? setNiftyError(true) : setBankNiftyError(true);
        }
    }), [optionList]);
    // useEffect(() => {
    //   setHideChartIframe(disableIframe);
    // }, [disableIframe]);
    // useLayoutEffect(() => {
    //   setHideChartIframe(disableIframe);
    // }, [disableIframe]);
    const getScripDetails = (element, index) => __awaiter(void 0, void 0, void 0, function* () {
        var _a, _b, _c;
        if (element.symbol) {
            try {
                const resp = yield getIndexPCR(element.title.split(" ")[0].toLowerCase());
                // const resp = { data: getIndexPCRResponse() };
                const singleElem = (_c = (_b = (_a = resp === null || resp === void 0 ? void 0 : resp.data.response) === null || _a === void 0 ? void 0 : _a.data) === null || _b === void 0 ? void 0 : _b.companylist) === null || _c === void 0 ? void 0 : _c.company[0];
                const expiry = singleElem === null || singleElem === void 0 ? void 0 : singleElem.expdate;
                element.expiry = expiry;
                const scripcode = yield getScripCodeFromExpiry(element.symbol, expiry, element.exchType);
                element.scripCode = (scripcode === null || scripcode === void 0 ? void 0 : scripcode.scripCode) || 0;
                setOptionList([...optionList]);
                setIndexPCRArr((prev) => {
                    const updated = [...prev];
                    updated[index] = singleElem;
                    return updated;
                });
            }
            catch (err) {
                console.error(err);
            }
        }
    });
    useEffect(() => {
        optionList.map((item, index) => {
            // fetchOptions(item, index);
            getScripDetails(item, index);
        });
    }, []);
    // const generateDOM = (): any => {
    //   return _.map(layouts[currentBreakpoint], function (l: Layout) {
    //     if (l.i === "option-chain") {
    //       return (
    //         // <Profiler id="OptionChainMini" key={l.i} onRender={onRenderCallback}>
    //         <OptionChain key={l.i} id="small-chain" position={1} />
    //         // </Profiler>
    //       );
    //     }
    //     // if (l.i === "fii") {
    //     //   return <FII key={l.i} id={`${l.i}`} />;
    //     // }
    //     // if (l.i === "vix" && showIframe) {
    //     //   return <Vix key={l.i} id={l.i} />;
    //     // }
    //     // if (l.i === "fo-momentum") {
    //     //   return <FOMomentum key={l.i} id={l.i} />;
    //     // }
    //     // if (l.i === "quants-top-stocks" && showIframe) {
    //     //   return <QuantsApp key={l.i} id={l.i} displayquants="top-stocks" />;
    //     // }
    //     // if (l.i === "quants-built-up-breadth" && showIframe) {
    //     //   return <QuantsApp key={l.i} id={l.i} displayquants="bias-strength" />;
    //     // }
    //     // if (l.i === "quants-hi-lo" && showIframe) {
    //     //   return <QuantsApp key={l.i} id={l.i} displayquants="high-low" />;
    //     // }
    //     // if (l.i === "NIFTY") {
    //     //   const singleScrip = optionList[0];
    //     //   return (
    //     //     <Overview
    //     //       key={l.i}
    //     //       name={singleScrip.title}
    //     //       id={singleScrip.title}
    //     //       spotToken={singleScrip.spotToken}
    //     //       scripCode={singleScrip.scripCode}
    //     //       expiry={singleScrip.expiry}
    //     //       symbol={singleScrip.symbol}
    //     //       exch={singleScrip.exch}
    //     //       exchType={singleScrip.exchType}
    //     //       indicatorWidgetSymbol={singleScrip.indicatorWidget}
    //     //       lastRate={singleScrip.LastRate}
    //     //       prevClose={singleScrip.PClose}
    //     //     />
    //     //   );
    //     // }
    //     if (l.i === "BANKNIFTY") {
    //       const singleScrip = optionList[1];
    //       return (
    //         // <Profiler id="OverviewBankNifty" onRender={onRenderCallback}>
    //         <Overview
    //           key={l.i}
    //           name={singleScrip.title}
    //           id={singleScrip.title}
    //           spotToken={singleScrip.spotToken}
    //           scripCode={singleScrip.scripCode}
    //           expiry={singleScrip.expiry}
    //           symbol={singleScrip.symbol}
    //           exch={singleScrip.exch}
    //           exchType={singleScrip.exchType}
    //           indicatorWidgetSymbol={singleScrip.indicatorWidget}
    //         />
    //         // </Profiler>
    //       );
    //     }
    //     return null;
    //   });
    // };
    // const getIsDraggable = useCallback(() => {
    //   if (currentBreakpoint == "lg" || currentBreakpoint == "sm") {
    //     return isDraggable;
    //   }
    //   return false;
    // }, [currentBreakpoint, isDraggable]);
    return (_jsx(_Fragment, { children: _jsxs("div", Object.assign({ className: `${styles.showcaseWrapper} ms-1` }, { children: [_jsxs("div", Object.assign({ className: `${styles.showcaseTopRow}` }, { children: [_jsx(OptionChain, { id: "small-chain", position: 1 }), _jsx(Overview
                        // key={l.i}
                        , { 
                            // key={l.i}
                            name: singleScrip.title, id: singleScrip.title, spotToken: singleScrip.spotToken, scripCode: singleScrip.scripCode, 
                            //scripCode={updatedScripcodes.scripCode_NIFTY}
                            expiry: singleScrip.expiry, symbol: singleScrip.symbol, exch: singleScrip.exch, exchType: singleScrip.exchType, indicatorWidgetSymbol: singleScrip.indicatorWidget, lastRate: singleScrip.LastRate, prevClose: singleScrip.PClose, iframeLoader: false, iframeError: niftyError, indexPCR: indexPCRArr[0] }), _jsx(Overview
                        // key={l.i}
                        , { 
                            // key={l.i}
                            name: singleScripBN.title, id: singleScripBN.title, spotToken: singleScripBN.spotToken, scripCode: singleScripBN.scripCode, 
                            // scripCode={updatedScripcodes.scripCode_BANKNIFTY}
                            expiry: singleScripBN.expiry, symbol: singleScripBN.symbol, lastRate: singleScripBN.LastRate, exch: singleScripBN.exch, exchType: singleScripBN.exchType, indicatorWidgetSymbol: singleScripBN.indicatorWidget, iframeLoader: false, iframeError: bankNiftyError, indexPCR: indexPCRArr[1] })] })), _jsxs("div", Object.assign({ className: `${styles.showcaseMiddleRow}` }, { children: [_jsx(VixWrapper, {}), _jsx(FII, { id: "fii" }), _jsx(FOMomentum, { id: "fo-momentum" })] }))] })) }));
};
export default Showcase;
